import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';

const Contact = ({ primaryContact = '--' }) => {
    return (
        <Col
            lg={6}
            md={12}
            className="py-3 d-flex px-3 py-2"
            title="Practice Contact">
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faAddressBook}
                size="lg"
            />
            &emsp;
            <div>{primaryContact ?? '--'}</div>
        </Col>
    );
};

export default Contact;
